import images from './image';
import APP2 from '../../app/assets/images/projectImage/aichatImage/app2.png'



const commonConstants = {
    driveClientId: "91239488574-pe3rcq6i5pkfebtfo5e87uk3oa5g40od.apps.googleusercontent.com",
    driveAPIKey: "AIzaSyDq_WLqqk1rq5R0DV6mCmbxK80c-BNvNNU",
    driveFolderId: "1bdGKPoqELfrMPfpXhg1x-PCd2lxDcBe8",
    google_sheet_deployed_url: (process.env.REACT_APP_GOOGLE_SHEET_DEPLOYED_URL as string) || "",

    clientTestimonials: [
        {
            name: 'Matt Throne',
            content: '"Job was done satisfactorily even if you have a tight schedule it can be managed effortlessly. Well done Sattva Tech"',
            img: images.MATTIMG
        },
        {
            name: 'Daniel J',
            content: '"It was great to work with the Sattva Tech, and the team got the job done and very fast too :)"',
            img: images.AJAYIMG
        },

        {
            name: 'Jessica K',
            content: '"They are flexible, hard working and cooperative and always willing to accommodate requests and better communication and schedule keeping. I had a good time working with them and will hire them again."',
            img: images.JESSICAIMG
        },
        {
            name: 'Radhika M',
            content: '"Anjali and her team did a really good job. Highly skilled and great attention to details. Will hire Sattva Tech again in near future. Will highly Recommend!"',
            img: images.RADHIKAIMG
        },
        {
            name: 'Ajay D',
            content: '"Anjali was outstanding and very professional in her work. Would definitely recommend her company Sattva Tech."',
            img: images.AJAYIMG
        },
    ],
}


export const allImages = [
    { key: 'APP2', url: APP2 },
];

export default commonConstants